import LinkDashboard from "./links/LinkDashboard";

function Dashboard() {
    return (
        <>
            <LinkDashboard />
        </>
    );
}

export default Dashboard;